var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgField(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.268 26.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    "data-name": "Path 3718",
    d: "M3,1028.36H23.317v3.255H3Z",
    transform: "translate(-3.001 -1028.36)",
    fill: "#ece7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    d: "M16.5,1028.36h20.32v3.255H16.5v-3.255Z",
    transform: "translate(5.448 -1028.36)",
    fill: "#ece7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    d: "M3,1031.366H5.436v16.249H3v-16.249Z",
    transform: "translate(-3.001 -1026.479)",
    fill: "#ece7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    "data-name": "Path 3721",
    d: "M5.5,1031.366H7.939v16.249H5.5Z",
    transform: "translate(-1.435 -1026.479)",
    fill: "#ece7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M8,1031.366H20.191v16.249H8v-16.249Z",
    transform: "translate(0.126 -1026.479)",
    fill: "#ece7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    d: "M16.5,1031.366H28.695v16.249H16.5v-16.249Z",
    transform: "translate(5.448 -1026.479)",
    fill: "#ece7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724",
    "data-name": "Path 3724",
    d: "M25,1031.366h2.448v16.249H25Z",
    transform: "translate(10.766 -1026.479)",
    fill: "#ece7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    "data-name": "Path 3725",
    d: "M27.5,1031.366h2.436v16.249H27.5Z",
    transform: "translate(12.332 -1026.479)",
    fill: "#ece7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M3,1042.364H23.317v3.251H3Z",
    transform: "translate(-3.001 -1019.596)",
    fill: "#ece7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M16.5,1042.364h20.32v3.251H16.5v-3.251Z",
    transform: "translate(5.448 -1019.596)",
    fill: "#ece7ea"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgField);
export default __webpack_public_path__ + "static/media/field.8f2befb29a0b8c8ca033cffa923ed071.svg";
export { ForwardRef as ReactComponent };